/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventParameter } from './EventParameter';
import {
    EventParameterFromJSON,
    EventParameterFromJSONTyped,
    EventParameterToJSON,
} from './EventParameter';

/**
 * 
 * @export
 * @interface EventSchema
 */
export interface EventSchema {
    /**
     * 
     * @type {string}
     * @memberof EventSchema
     */
    event_type: string;
    /**
     * 
     * @type {Array<EventParameter>}
     * @memberof EventSchema
     */
    parameters: Array<EventParameter>;
    /**
     * 
     * @type {string}
     * @memberof EventSchema
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EventSchema
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof EventSchema
     */
    category?: string;
    /**
     * Available attachment generators for this event (e.g., ["appointment.ics"])
     * @type {Array<string>}
     * @memberof EventSchema
     */
    attachment_generators?: Array<string>;
}

/**
 * Check if a given object implements the EventSchema interface.
 */
export function instanceOfEventSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "event_type" in value;
    isInstance = isInstance && "parameters" in value;

    return isInstance;
}

export function EventSchemaFromJSON(json: any): EventSchema {
    return EventSchemaFromJSONTyped(json, false);
}

export function EventSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'event_type': json['event_type'],
        'parameters': ((json['parameters'] as Array<any>).map(EventParameterFromJSON)),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'category': !exists(json, 'category') ? undefined : json['category'],
        'attachment_generators': !exists(json, 'attachment_generators') ? undefined : json['attachment_generators'],
    };
}

export function EventSchemaToJSON(value?: EventSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'event_type': value.event_type,
        'parameters': ((value.parameters as Array<any>).map(EventParameterToJSON)),
        'name': value.name,
        'description': value.description,
        'category': value.category,
        'attachment_generators': value.attachment_generators,
    };
}

